import { handleDeleteApi, handlePatchUpdate, handlePostApi } from '@/api/crud';
import { customerApiEndpoints } from '@/api/endpoints';
import ConfirmModal from './confirmModal';
import { useFetch } from '@/hooks';
import ChangePasswordModal from '@/pages/changePassword/ChangePasswordModal';
import { enablePaginationOrNot } from '@/utils/common';
import { globalSearch } from '@/utils/search/Search';
import {
  EditFilled,
  PlusOutlined,
  SearchOutlined,
  KeyOutlined,
  ClearOutlined,
} from '@ant-design/icons';
import { Tag, Button, Input, Table, Tooltip } from 'antd';
import { useEffect, useState } from 'react';
import { useUsers } from './useUsers';
import { Link } from 'react-router-dom';
import '@/assets/style/modern-group-list.css';

const baseColumns = [
  {
    title: 'S. N.',
    render: (_, __, index) => index + 1,
    align: 'center',
    width: 50,
  },
  {
    title: 'User Name',
    dataIndex: 'username',
    key: 'username',
    align: 'left',
    // width: '20',
  },
  {
    title: 'Full Name',
    dataIndex: 'name',
    key: 'name',
    align: 'left',
    // width: '20%',
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    align: 'left',
    // width: '20%',
  },
  {
    title: 'Mobile',
    dataIndex: 'mobile',
    key: 'mobile',
    align: 'left',
    // width: '20%',
  },
  // {
  //   title: 'OTP',
  //   dataIndex: 'otpStatus',
  //   key: 'otpStatus',
  //   align: 'center',
  //   // width: '20%',
  // },

  // {
  //   title: 'Subscription',
  //   dataIndex: 'subscription',
  //   key: 'subscription',
  //   align: 'center',
  // },
  // {
  //   title: 'Remaining Days',
  //   dataIndex: 'remainingDays',
  //   key: 'remainingDays',
  //   align: 'center',
  // },
  {
    title: 'Company',
    dataIndex: 'companies',
    key: 'companies',
    align: 'left',
    // width: '20%',
  },
  {
    title: 'Branch',
    dataIndex: 'branches',
    key: 'branches',
    align: 'left',
    // width: '20%',
  },
  {
    title: 'Store',
    dataIndex: 'stores',
    key: 'stores',
    align: 'left',
  },
  {
    title: 'Action',
    dataIndex: 'action',
    key: 'action',
    align: 'center',
    // width: '20%',
  },
];

const Customers = () => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openUserActivateModal, setOpenUserActivateModal] = useState(false);
  const [openUserDeactivateModal, setOpenUserDeactivateModal] = useState(false);
  const [openClearTokenModal, setOpenClearTokenModel] = useState(false);
  const [openIsAdminModal, setOpenIsAdminModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [isShow, setIsShow] = useState();
  const [openPasswordModal, setOpenPasswordModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [selectedUsername, setSelectedUsername] = useState(null);

  const { data, isLoading, refresh } = useUsers();
  const [id, setId] = useState(null);

  const handleCancel = () => {
    setOpen(false);
    setOpenUserActivateModal(false);
    setOpenUserDeactivateModal(false);
    setOpenIsAdminModal(false);
    setId(null);
  };

  const handleUserActivate = () => {
    handlePatchUpdate(
      customerApiEndpoints.active,
      { userId: id },
      setLoading,
      refresh,
    );
    setOpenUserActivateModal(false);
  };

  const handleClearToken = () => {
    handlePostApi(
      customerApiEndpoints.clearToken,
      id,
      setLoading,
      null,
      refresh,
    );
    setId(null);
    setOpenClearTokenModel(false);
  };

  const handleDeactivateUserModal = () => {
    handleDeleteApi(id, customerApiEndpoints.delete, setLoading, refresh);
    setOpenUserDeactivateModal(false);
  };
  useEffect(() => {
    const userIsShow = sessionStorage.getItem('isShow');

    setIsShow(userIsShow);
  }, []);

  // Determine columns dynamically based on `isShow` value
  // const getColumns = () => {
  //   let columns = [...baseColumns]; // Start with the base columns

  //   if (!isShow) {
  //     columns.push(
  //       {
  //         title: 'Company',
  //         dataIndex: 'companies',
  //         key: 'companies',
  //         align: 'center',
  //       },
  //       {
  //         title: 'Role',
  //         dataIndex: 'role',
  //         key: 'role',
  //         align: 'center',
  //       },
  //     );
  //   }

  //   return columns;
  // };

  const handlePasswordChange = () => {
    setOpenPasswordModal(false);
    setSelectedUsername(null);
    setSelectedUserId(null);
  };

  return (
    <>
      {/*<ConfirmModal
        open={open}
        handleOk={() => setOpen(false)}
        handleCancel={handleCancel}
      />

      <ConfirmModal
        defaultType="primary"
        OkBgColor="green"
        open={openUserActivateModal}
        handleOk={handleUserActivate}
        handleCancel={handleCancel}
      />

      <ConfirmModal
        open={openUserDeactivateModal}
        handleOk={handleDeactivateUserModal}
        handleCancel={handleCancel}
      />*/}
      <ConfirmModal
        isVisible={openClearTokenModal}
        onConfirm={handleClearToken}
        onClose={() => setOpenClearTokenModel(false)}
        title="Are you sure?"
        content="This action will clear the user token"
      />

      {/*<ConfirmModal
        open={openIsAdminModal}
        handleOk={() =>
          handlePatchUpdate(
            customerApiEndpoints.isAdmin,
            { userId: id },
            setLoading,
            refresh,
          )
        }
        handleCancel={handleCancel}
      />*/}

      <ChangePasswordModal
        open={openPasswordModal}
        loading={loading}
        onCancel={() => setOpenPasswordModal(false)}
        onFinish={handlePasswordChange}
        selectedUserId={selectedUserId}
        username={selectedUsername}
      />

      <div className="modern-group-page">
        <div className="modern-group-header-row">
          <div className="modern-group-header">
            <h1 className="modern-group-title">Customers</h1>
            <p className="modern-group-subtitle">
              Manage and organize your customers
            </p>
          </div>
          <div className="modern-group-actions">
            <Input
              className="header-search"
              name="query"
              value={searchQuery}
              placeholder="Search customer..."
              prefix={<SearchOutlined />}
              onChange={(event) => setSearchQuery(event.target.value)}
              style={{ width: '300px' }}
            />
            <Link to="/user/create/" className="tw-w-fit">
              <Button type="primary" className="centered">
                <PlusOutlined />
                Create
              </Button>
            </Link>
          </div>
        </div>

        <div className="table-responsive modern-table-wrapper">
          <Table
            scroll={{ x: true, y: 'calc(100vh - 260px)' }}
            size="large"
            bordered
            loading={isLoading || loading}
            columns={baseColumns?.map((col) => ({
              ...col,
              onCell: () => ({
                style: {
                  padding: '6px 8px',
                },
              }),
            }))}
            expandable={true}
            className="ant-border-space"
            pagination={!isLoading ? enablePaginationOrNot(data?.data) : false}
            dataSource={
              !isLoading
                ? globalSearch(data?.data, searchQuery)?.map((user, index) => ({
                    key: user.referenceId,
                    index: index + 1,
                    username: user.username,
                    name: `${user.firstName} ${user.lastName}`,
                    email: user.email,
                    mobile: user.mobileNumber,
                    subscription: user.subscription,
                    remainingDays: user.remainingDays,
                    // ...(isShow === false && {
                    companies: user.companies?.join(', '),
                    branches: user.branches?.join(', '),
                    // Stores come back as objects, unlike companies/branches.
                    stores: user.stores
                      ?.map((store) => store?.name)
                      ?.filter(Boolean)
                      ?.join(', '),
                    role: user.role || '-',
                    // }),
                    otpStatus: (
                      <div className="tw-flex tw-gap-2 tw-items-center tw-justify-center">
                        {user.otp}
                        {user.otpVerified ? (
                          <Tag color="green">Verified</Tag>
                        ) : (
                          <Tag color="red">Unverified</Tag>
                        )}
                      </div>
                    ),
                    action: (
                      <div className="ant-action tw-flex tw-gap-3 tw-justify-center tw-items-center">
                        <Tooltip title="Edit">
                          <Link
                            to={`/user/${user.referenceId}/edit/`}
                            className="tw-inline-flex tw-cursor-pointer hover:tw-bg-blue-200 tw-rounded-full tw-p-1"
                          >
                            <EditFilled className="tw-text-blue-600" />
                          </Link>
                        </Tooltip>
                        <Tooltip title="Clear Token">
                          <span
                            className="tw-inline-flex tw-cursor-pointer hover:tw-bg-yellow-200 tw-rounded-full tw-p-1"
                            style={{ color: '#d89614' }}
                            onClick={() => {
                              setOpenClearTokenModel(true);
                              setId(user.username);
                            }}
                          >
                            <ClearOutlined />
                          </span>
                        </Tooltip>
                        <Tooltip title="Change Password">
                          <span
                            className="tw-inline-flex tw-cursor-pointer hover:tw-bg-red-200 tw-rounded-full tw-p-1"
                            style={{ color: 'red' }}
                            onClick={() => {
                              setSelectedUserId(user.referenceId);
                              setSelectedUsername(user.username);
                              setOpenPasswordModal(true);
                            }}
                          >
                            <KeyOutlined />
                          </span>
                        </Tooltip>
                      </div>
                    ),
                  }))
                : []
            }
          />
        </div>
      </div>
    </>
  );
};

export default Customers;
